module.exports = __webpack_public_path__ + "static/apextracker-8f79c884c3772015645b6055df0a1c1e.png";